import React from 'react';
import { shortcuts } from '../../config/shortcuts';

export const ShortcutsPage: React.FC = () => {
  const categories = Array.from(new Set(shortcuts.map((s) => s.category)));

  const getKeyDisplay = (shortcut: typeof shortcuts[0]) => {
    const key = shortcut.key.replace('Key', '');
    if (shortcut.modifier) {
      return `${shortcut.modifier.charAt(0).toUpperCase() + shortcut.modifier.slice(1)} + ${key}`;
    }
    return key;
  };

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-zinc-200">Keyboard Shortcuts</h1>
      <p className="text-zinc-400 mb-8">
        Master the Haptic Music Player with these keyboard shortcuts. All shortcuts can be
        toggled on/off in the settings.
      </p>

      {categories.map((category) => (
        <div key={category} className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 capitalize text-zinc-200">{category}</h2>
          <div className="bg-zinc-800/50 backdrop-blur rounded-lg border border-zinc-700/50">
            {shortcuts
              .filter((s) => s.category === category)
              .map((shortcut) => (
                <div
                  key={shortcut.id}
                  className="flex items-center justify-between p-4 border-b border-zinc-700/50 last:border-0"
                >
                  <div>
                    <h3 className="font-medium text-zinc-200">{shortcut.description}</h3>
                    {shortcut.condition && (
                      <p className="text-sm text-zinc-400 mt-1">
                        {shortcut.condition}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center gap-2">
                    <kbd className="px-3 py-1 text-sm bg-zinc-900/50 text-yellow-500 rounded-md font-mono border border-zinc-700/50">
                      {getKeyDisplay(shortcut)}
                    </kbd>
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};
